import React, { useState, useEffect } from "react";
import jwt_decode from "jwt-decode";
import { useLocation } from "react-router-dom";

export const UsuarioContext = React.createContext();

const PROVINCIAS_SENALIZACION = [
  "barcelona", "girona", "gerona", "lleida", "lerida", "tarragona",
  "madrid",
  "valencia",
  "castellon", "castello",
  "alicante", "alacant",
];

const PROVINCIAS_CAI = [
  "barcelona", "girona", "gerona", "lleida", "lerida", "tarragona"
];
const DIACRITICOS = new RegExp("[\\u0300-\\u036f]", "g");
const normalizar = (txt) =>
  (txt || "")
    .toString()
    .trim()
    .toLowerCase()
    .normalize("NFD")
    .replace(DIACRITICOS, "");
    
const esProvinciaSenalizacion = (provincia) =>
  normalizar(provincia)
    .split("/")
    .some((parte) => PROVINCIAS_SENALIZACION.includes(parte.trim()));

const esProvinciaCai = (provincia) =>
  normalizar(provincia)
    .split("/")
    .some((parte) => PROVINCIAS_CAI.includes(parte.trim()));

export const UsuarioProvider = ({ children }) => {
  const [user, setUser] = useState(localStorage.getItem("token"));
  const location = useLocation();

  const checkToken = () => {
    const token = localStorage.getItem("token");
    if (token) {
      const decoded = jwt_decode(token);
      if (decoded.exp * 1000 > Date.now()) {
        const ownToken = decoded?.data?.ownToken;
        let ownData;
        if (ownToken) {
          const {data: ownDecodedData, ...restDecodedData} = jwt_decode(decoded?.data?.ownToken);
          ownData = {...restDecodedData, ...ownDecodedData, token: ownToken};
        }
        const datos = {
          exp: decoded?.exp,
          iat: decoded?.iat,
          id: decoded?.data?.id,
          user_id: decoded?.data?.user_id,
          nif: decoded?.data?.nif,
          nombre: decoded?.data?.nombre,
          apellidos: decoded?.data?.apellidos,
          email: decoded?.email,
          rol: decoded?.rol,
          gruposServicios: decoded?.data.gruposServicios,
          servicios: decoded?.data.servicios,
          tieneKae: decoded?.data.gruposServicios?.includes(4) || false,
          tieneCai: decoded?.data.gruposServicios?.includes(3) || false,
          showAll: decoded?.data.showAll,
          numChildsAAFF: decoded?.data.numChildsAAFF,
          razonSocial: decoded?.data.razonSocial,
          parent: decoded?.data.parent,
          // Solo los tecnicos del piloto del QR (QR_TECNICOS_PERMITIDOS en el API)
          puedeUsarQR: decoded?.data?.puedeUsarQR === true,
          ownData
        }
        if(decoded?.rol === "AAFF"){
          datos.tecnico = decoded?.data.tecnico
          datos.consultores = decoded?.data.consultores
          datos.comerciales = decoded?.data.comerciales
          datos.legalia = decoded?.data.legalia
          datos.tieneLegalia = ["Esencial", "Pro", "Elite"].includes(decoded?.data.legalia)
          datos.nombreContacto = decoded?.data.nombreContacto
          datos.provincia = decoded?.data.provincia
          datos.esCataluna = esProvinciaSenalizacion(decoded?.data.provincia)
          datos.esProvinciasCai = esProvinciaCai(decoded?.data.provincia)
        }
        if(decoded?.rol === "TECH_COOR"){
          datos.equipo = decoded?.data.equipo
        } 
        setUser(datos);
      } else {
        setUser(null);
      }
    } else {
      setUser(null);
    }
  }
  useEffect(() => {
    window.addEventListener("storage", checkToken);

      return () => {
        // When the component unmounts remove the event listener
        window.removeEventListener("storage", checkToken);
      };
  }, []);
  

  useEffect(checkToken, [location]);

  return (
    <UsuarioContext.Provider value={user}>
      {children}
    </UsuarioContext.Provider>
  );
};
